import api from "@/services";

/**
 * Opções de status dos alunos
 * Constante reutilizável para MultiSelect e outros componentes
 */
export const candidateStatusOptions = [
    { id: 'Candidato', name: 'Candidato' },
    { id: 'Em andamento', name: 'Em andamento' },
    { id: 'Matriculado', name: 'Matriculado' },
];

/**
 * Unidades federativas (UF) para o endereço do candidato
 */
export const brazilianStates = [
    { id: 'AC', name: 'AC' },
    { id: 'AL', name: 'AL' },
    { id: 'AP', name: 'AP' },
    { id: 'AM', name: 'AM' },
    { id: 'BA', name: 'BA' },
    { id: 'CE', name: 'CE' },
    { id: 'DF', name: 'DF' },
    { id: 'ES', name: 'ES' },
    { id: 'GO', name: 'GO' },
    { id: 'MA', name: 'MA' },
    { id: 'MT', name: 'MT' },
    { id: 'MS', name: 'MS' },
    { id: 'MG', name: 'MG' },
    { id: 'PA', name: 'PA' },
    { id: 'PB', name: 'PB' },
    { id: 'PR', name: 'PR' },
    { id: 'PE', name: 'PE' },
    { id: 'PI', name: 'PI' },
    { id: 'RJ', name: 'RJ' },
    { id: 'RN', name: 'RN' },
    { id: 'RS', name: 'RS' },
    { id: 'RO', name: 'RO' },
    { id: 'RR', name: 'RR' },
    { id: 'SC', name: 'SC' },
    { id: 'SP', name: 'SP' },
    { id: 'SE', name: 'SE' },
    { id: 'TO', name: 'TO' },
];

export const userRoleOptions = [
    { id: 'admin', name: 'Administrador' },
    { id: 'comercial', name: 'Comercial' },
];

export const studentStatusOptions = [
    { id: 'Ativo', name: 'Ativo' },
    { id: 'Trancado', name: 'Trancado' },
    { id: 'Inativo', name: 'Inativo' },
    { id: 'Concluído', name: 'Concluído' },
    { id: 'Evadido', name: 'Evadido' },
    { id: 'Desistente', name: 'Desistente' },
    { id: 'Suspenso', name: 'Suspenso' },
];

export function serialize(obj) {
    let queryString = "";
    for (let key in obj) {
        queryString += `&${key}=${obj[key]}`;
    }
    return queryString;
}

export function errorsToString(arErrors) {
    let list = '<ol>'
    for (const key in arErrors)
        list += `<li>${arErrors[key][0]}</li>`
    list += '</ol>'
    return list;
}

export function filterNonNumeric(ev) {
    ev.target.value = ev.target.value.replace(/[^0-9]/g, "");
}

export function convertDateToDB(date) {
    if (!date) return null
    const [day, month, year] = date.split('/')
    return `${year}-${month}-${day}`
}

export function generateHash(prefix = '') {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = 10;
    let result = '';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters.charAt(randomIndex);
    }
    return prefix + result;
}

export function displayDateInFull(date) {
    const dataSplit = date.split('/');
    const day = parseInt(dataSplit[0]);
    const month = parseInt(dataSplit[1]);
    const year = parseInt(dataSplit[2]);

    const MonthsOfTheYear = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

    // Formata o dia para ter dois dígitos
    const formattedDay = day.toString().padStart(2, '0');

    return `${formattedDay} de ${MonthsOfTheYear[month - 1]} de ${year}`;
}

export function handlerDelete(id, endpoint) {

    this.$swal({
        title: "Deseja confirmar a ação?",
        text: "Você não será capaz de reverter isso!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apague!",
        cancelButtonText: "Não, cancele!",
        buttonsStyling: true,
    }).then(async (isConfirm) => {
        if (isConfirm.value === true) {
            try {
                const { data } = await api.delete(`/${endpoint}/${id}`);
                Toast.fire(data.message, "", "success");
                this.getItens();
            } catch (error) {
                Toast.fire(error.response.data.message, "", "error");
            }
        }
    });
}

export function cpfWithMask(string) {
    const numericCpf = string.replace(/\D/g, '');
    return numericCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function slug(string) {
    return string
    .normalize("NFD") // Normaliza a string (decomposição)
    .replace(/[\u0300-\u036f]/g, "") // Remove os acentos (caracteres diacríticos)
    .replace(/[^\w\s-]/g, "") // Remove caracteres especiais (exceto hífens e espaços)
    .replace(/\s+/g, "-") // Substitui espaços em branco por hífens
    .replace(/-+/g, "-") // Remove múltiplos hífens seguidos
    .toLowerCase(); // Converte para letras minúsculas
}

export function decimal(v) {
    return v.replace(/\D/g, '') / 100;
}

export function generateNameFile(prefixo) {
    const timestamp = Date.now();
    const name = `${prefixo}_${timestamp}`;
    return name;
}

/**
 * Converte erro de blob em mensagem legível
 * Útil para requisições com responseType: "blob"
 * @param {Error} error - Objeto de erro do axios
 * @param {Function} callback - Função callback que recebe a mensagem de erro (string)
 */
export function handleBlobError(error, callback) {
    // Quando responseType é blob, os erros também vêm como blob
    // Precisamos converter de volta para JSON
    if (error.response && error.response.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
            try {
                const errorData = JSON.parse(reader.result);
                callback(errorData.message || 'Erro ao processar solicitação');
            } catch (e) {
                callback('Erro ao processar solicitação');
            }
        };
        reader.readAsText(error.response.data);
    } else if (error.response && error.response.data && error.response.data.message) {
        callback(error.response.data.message);
    } else {
        callback(error.message || 'Erro desconhecido');
    }
}

/** URL para download de PDF de documentos com cache-buster. */
export function documentStorageUrl(folder, fileName) {
    return `/documents/storage/${folder}/${fileName}?t=${Date.now()}`;
}